class BoostWidgetIntegration {
  constructor() {
    this.registerEvents();
  }

  registerEvents() {
    // Register with Boost widget
    boostWidgetIntegration.regisCustomization(() => this.afterRender());

    // Also run after window load
    window.addEventListener("load", () => this.afterRender());
  }

  afterRender() {
    try {
      const boostGrid = document.querySelector('.boost-sd__product-list');

      if (!boostGrid) {
        console.log("Boost grid not found, skipping...");
        return;
      }

      if (typeof boostSDCustomData !== 'undefined' && boostSDCustomData?.collectImage !== null) {
        console.log("load me");
        this.extractAllProductData(boostGrid);
      }
    } catch (error) {
      console.warn(error);
    }
  }

  extractAllProductData(boostGrid) {
    const productItems = boostGrid.querySelectorAll('.boost-sd__product-item');

    productItems.forEach((item) => {
      const productData = this.getProductData(item);
      if (productData) {
        this.displayElements(item, productData);
      }
    });
  }

  displayElements(element, productData) {
    const price = parseFloat(productData.priceMin || '0');
    const comparePrice = parseFloat(productData.compareAtPriceMin || '0');
    const tags = productData.tags || [];

    const finalPrices = this.calculateDiscounts(price, comparePrice, tags);

    const template = this.templateElement(finalPrices.price, finalPrices.comparePrice, finalPrices.savings);
    const templateTag = this.templateElementTag(finalPrices.percentOffFinal);

    const { product_tag, products_affected } = boostSDCustomData;
    
    let shouldRender = false;

    if (products_affected === 'whole_store') {
      shouldRender = true;
    } else if (products_affected === 'by_tag' && tags.includes(product_tag)) {
      shouldRender = true;
    }

    if (!shouldRender) return;

    const priceElement = element.querySelector('.boost-sd__product-price-wrapper');
    const topBadge = element.querySelector('.boost-sd__product-image-column--in-top');
    const topBadgeSale = topBadge?.querySelector('.boost-sd__product-label--sale');
    console.log(topBadge);
    if (priceElement) {
      priceElement.innerHTML = template;
    }
    
    if(topBadge && topBadge.children.length == 0 ){
      topBadge.innerHTML = templateTag;
    }else{
      if(topBadgeSale){
        topBadgeSale.remove();
      }
      topBadge.insertAdjacentHTML('beforeend', templateTag);
    }
  }

  calculateDiscounts(price, comparePrice = 0, tags) {
    const { discount_type, discount_value, product_tag, products_affected } = boostSDCustomData;

    let applyDiscount = false;

    // Determine if discount should be applied
    if (products_affected === 'whole_store') {
      applyDiscount = true;
    } else if (products_affected === 'by_tag' && tags.includes(product_tag)) {
      applyDiscount = true;
    }

    if(comparePrice == 0){
      comparePrice = price;
    }


    let discountedPrice = price;
    let savings = 0;

    if (applyDiscount) {
      if (discount_type === 'dollar') {
        discountedPrice = Math.max(price - discount_value, 0); // Avoid negative price
        savings = comparePrice - discountedPrice;
      } else if (discount_type === 'percent') {
        const percentOff = price * (discount_value / 100);
        discountedPrice = Math.max(price - percentOff, 0);
        savings = comparePrice - discountedPrice;
      }

      savings = Math.floor(savings);
    }

    
    let percentOffFinal = 0;
    if (comparePrice > 0) {
      percentOffFinal = ((comparePrice - discountedPrice) / comparePrice) * 100;
      percentOffFinal = Math.round(percentOffFinal);
    }


    // Format to 2 decimal places
    discountedPrice = discountedPrice.toFixed(2);
    const formattedComparePrice = comparePrice > 0 ? comparePrice.toFixed(2) : price.toFixed(2);
    savings = savings.toFixed(0);

    return {
      price: discountedPrice,
      comparePrice: formattedComparePrice,
      savings: savings,
      percentOffFinal: percentOffFinal
    };
  }

  templateElement(price, comparePrice, savings) {
    return `
      <span aria-hidden="true" class="boost-sd__product-price-content boost-sd__product-price-content--text-align-left">
        <span class="boost-sd__product-price--sale">
          <span class="boost-sd__format-currency">${this.formatMoney(price)}</span>
        </span>
        <span class="boost-sd__format-currency boost-sd__format-currency--price-compare boost-sd__product-price--compare">
          <span class="boost-sd__format-currency">${this.formatMoney(comparePrice)}</span>
        </span>
      </span>
      <span aria-hidden="true" class="boost-sd__product-price--saving">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 4.50911C5.89533 4.50911 5 5.10578 5 5.84245C5 6.57911 5.89533 7.17578 7 7.17578C8.10467 7.17578 9 7.77245 9 8.50911C9 9.24578 8.10467 9.84245 7 9.84245M7 4.50911V9.84245M7 4.50911C7.74 4.50911 8.38667 4.77711 8.73267 5.17578M7 4.50911V3.84245M7 9.84245V10.5091M7 9.84245C6.26 9.84245 5.61333 9.57445 5.26733 9.17578M13 7.17578C13 7.96371 12.8448 8.74393 12.5433 9.47188C12.2417 10.1998 11.7998 10.8613 11.2426 11.4184C10.6855 11.9756 10.0241 12.4175 9.2961 12.7191C8.56815 13.0206 7.78793 13.1758 7 13.1758C6.21207 13.1758 5.43185 13.0206 4.7039 12.7191C3.97595 12.4175 3.31451 11.9756 2.75736 11.4184C2.20021 10.8613 1.75825 10.1998 1.45672 9.47188C1.15519 8.74393 1 7.96371 1 7.17578C1 5.58448 1.63214 4.05836 2.75736 2.93314C3.88258 1.80792 5.4087 1.17578 7 1.17578C8.5913 1.17578 10.1174 1.80792 11.2426 2.93314C12.3679 4.05836 13 5.58448 13 7.17578Z" stroke="#305AD0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        <span class="boost-sd__format-currency">${this.formatMoney(savings)}</span>
      </span>
    `;
  }

  templateElementTag(percentsavings){
    return `<div class="boost-sd__product-label boost-sd__product-label--text boost-sd__product-label--capsule boost-sd__product-label--sale">
              <span class="boost-sd__product-label-text">
                <span>Save ${percentsavings}%</span>
              </span>
            </div>`
  }

  formatMoney(amount, format = window.themeVariables.settings.moneyFormat) {
    const formattedAmount = (amount / 1).toFixed(2); // Divide by 1 to ensure it's a number
    return format.replace('{{amount}}', formattedAmount);
  }

  getProductData(element) {
    if (!element) {
      console.error('No element provided for data extraction.');
      return null;
    }

    let rawData = element.getAttribute('data-product');
    if (!rawData) {
      console.error('No data-product attribute found.');
      return null;
    }

    // Decode HTML entities
    let decodedData = rawData
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&#39;/g, "'");

    try {
      const productData = JSON.parse(decodedData);

      // If variants is still a string, parse that too
      if (typeof productData.variants === 'string') {
        productData.variants = JSON.parse(productData.variants);
      }

      return productData;
    } catch (e) {
      console.error('Error parsing product data:', e);
      return null;
    }
  }
}

// Initialize the class
new BoostWidgetIntegration();
